import React, { useMemo, useRef, useState } from 'react';
import { StyledPopover, ListComponentWrap } from './styled';
const defaultPosition = ['bottom', 'top', 'right', 'left'];
export const Menu = ({ isOpen, children, content, listComponent: ListComponent = 'div', stretch, position = defaultPosition, ...props }) => {
    var _a;
    const positions = typeof position === 'string' ? [position] : position;
    const popperRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const modifiers = useMemo(() => {
        return [
            {
                name: 'sameWidth',
                enabled: Boolean(stretch),
                phase: 'beforeWrite',
                requires: ['computeStyles'],
                fn: ({ state }) => {
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                effect: ({ state }) => {
                    /* @ts-ignore */
                    state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
                }
            }
        ];
    }, [stretch]);
    const childProps = {
        ...((_a = children === null || children === void 0 ? void 0 : children.props) !== null && _a !== void 0 ? _a : {}),
        ref: setAnchorEl
    };
    return (React.createElement(React.Fragment, null,
        React.cloneElement(children, childProps),
        React.createElement(StyledPopover, { ref: popperRef, isOpen: isOpen, anchorEl: anchorEl, positions: positions, modifiers: modifiers, ...props },
            React.createElement(ListComponentWrap, null,
                React.createElement(ListComponent, null, content)))));
};
